<script lang="ts" setup>
import type { ShopTheLookTypeFragment } from '#graphql-operations'

const { name, look } = defineProps<{
  name: string
  look: ShopTheLookTypeFragment
}>()
</script>

<template>
  <UiDialog
    :name="name"
    class="look-modal"
    dialog-type="responsive"
  >
    <template #dialogHeader>
      <span class="dialog__title">
        {{ $t('Shop all products') }} ({{ look?.Products?.length || 0 }})
      </span>
    </template>

    <ul
      v-if="look?.Products?.length"
      class="look-modal__list"
    >
      <li
        v-for="{ product } in look?.Products"
        :key="product.id"
        class="look-modal__item"
      >
        <ProductTile
          :product="product"
          class="look-modal__product product-item--horizontal"
          :show-options="{ wishlist: true, colorVariants: false, labels: false }"
        >
          <template #additional>
            <ProductActionEs
              class="product-item__add-to-cart"
              :product="product"
            />
          </template>
        </ProductTile>
      </li>
    </ul>
  </UiDialog>
</template>

<style>
@import url("~layers/components/Look/Modal.css");
</style>
